/**
 * Documents-tab id prefix marking an admin_notes-backed attachment (e.g. a
 * key handover photo) rather than a tenant_documents row. Shared with
 * TenantProfileDialog's renameDocument/deleteDocument so the routing lives
 * in exactly one place.
 */
export const DOC_NOTE_PREFIX = "note-";

/**
 * Documents-tab id of the generated "Lease contract.pdf" card. It is not a row:
 * the tab builds it from the booking's contract URL, so its only editable
 * property is `bookings.contract_display_name`.
 */
export const CONTRACT_DOC_ID = "contract";

/** Which table + row id a Documents-tab card's `docId` resolves to. For the
 *  contract card the table is `bookings` and `rowId` is empty: the caller
 *  already holds the booking id. */
export function resolveDocTarget(docId: string): {
  table: "admin_notes" | "tenant_documents" | "bookings";
  rowId: string;
} {
  if (docId === CONTRACT_DOC_ID) return { table: "bookings", rowId: "" };
  return docId.startsWith(DOC_NOTE_PREFIX)
    ? { table: "admin_notes", rowId: docId.slice(DOC_NOTE_PREFIX.length) }
    : { table: "tenant_documents", rowId: docId };
}
